var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup41(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37,
    height: 65,
    viewBox: "0 0 37 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 37,
    height: 65,
    transform: "translate(0 0.367)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(0 0.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(0 -0.885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M31.83,0H5.056A5.062,5.062,0,0,0,0,5.056V60.52a5.062,5.062,0,0,0,5.056,5.056H31.83a5.062,5.062,0,0,0,5.056-5.056V5.056A5.062,5.062,0,0,0,31.83,0M10.246,2.049H26.64V3.586a.995.995,0,0,1-1.025,1.025H11.271a.995.995,0,0,1-1.025-1.025ZM34.837,60.52a3.017,3.017,0,0,1-3.007,3.007H5.056A3.017,3.017,0,0,1,2.049,60.52V5.056A3.017,3.017,0,0,1,5.056,2.049H8.2V3.586A3.043,3.043,0,0,0,11.271,6.66H25.616a3.043,3.043,0,0,0,3.074-3.074V2.049H31.83a3.017,3.017,0,0,1,3.007,3.007Z",
    transform: "translate(0 0.481)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(0 -0.885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M59.566,128.6H55.437l.512-4.488a1.032,1.032,0,0,0-2.049-.246l-.528,4.734h-8.2l.558-4.488a1.032,1.032,0,0,0-2.049-.246l-.558,4.734H38.049a1.025,1.025,0,0,0,0,2.049h4.836l-.979,8.2H37.025a1.025,1.025,0,1,0,0,2.049h4.642l-.543,4.488a1.024,1.024,0,0,0,.9,1.147h.123a1.025,1.025,0,0,0,1.025-.9l.558-4.734h8.2l-.512,4.488a1.025,1.025,0,0,0,.856,1.147h.123a1.025,1.025,0,0,0,1.025-.9l.558-4.734h4.565a1.025,1.025,0,1,0,0-2.049H54.218l.979-8.2h4.37a1.025,1.025,0,0,0,0-2.049m-7.413,10.246h-8.2l.979-8.2h8.2Z",
    transform: "translate(-29.852 -101.478)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup41);
export default __webpack_public_path__ + "static/media/Group41.6755e76f7c2b9801ad3ff94bdf3f3f56.svg";
export { ForwardRef as ReactComponent };